import { inject, observer, Provider } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import b from 'b_';
import initBrowserStores from '../../browser/initBrowserStores';
import BrowserStore from '../../browser/stores/BrowserStore';
import { HelpButton, HelpButtonAction } from '../../stores/BrowserBarOptions';
import ConsoleStore from '../../stores/ConsoleStore';
import FlagStore from '../../stores/FlagStore';
import { FTBody } from '../Fuse';
import TopBarAlternative from '../TopBarAlternative/TopBarAlternative';
import './BrowserBarPreview.css';

const block = b.lock('BrowserBarPreview');

const trueStore = new FlagStore(true, () => null);
const falseStore = new FlagStore(false, () => null);
const desktopEnv = {
    screen: {
        isMobile: false,
        isTablet: false,
        isSmallDesktop: false,
    },
    attachListeners: () => null,
};

const mobileEnv = {
    screen: {
        isMobile: true,
        isTablet: false,
        isSmallDesktop: false,
    },
    attachListeners: () => null,
};

const commonBrowser = {
    topBarUnpinned: falseStore,
    topBarNeedsMinimization: falseStore,
    canExitIsolation: () => true,
    blockAdsByDefault: true,
    showNotification: () => null,
    closeNotification: () => null,
    isTopBarMinificationAllowed: () => false,
    topBarMenu: falseStore,
    adBlock: trueStore,
    adBlockModal: falseStore,
    isConsolePreview: true,
};

const urlIsoBrowser = {
    pageStatus: BrowserStore.PAGE_STATUS.SECURE_SITE,
    isHomePage: false,
    urlInputValue: 'https://urlisolation.com',
};

const urlIsoEnv = {
    isBrowserDefense: false,
    isUrlIsolation: true,
};

class BrowserBarPreview extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        browserBarOptions: PropTypes.object, // eslint-disable-line react/forbid-prop-types,
    };

    desktopBrowserIsoStore = initBrowserStores({
        browser: { ...commonBrowser },
        env: { ...desktopEnv },
    }, false);

    mobileBrowserIsoStore = initBrowserStores({
        browser: { ...commonBrowser },
        env: { ...mobileEnv },
    }, false);

    browserIsoStores = [this.desktopBrowserIsoStore, this.mobileBrowserIsoStore];

    desktopUrlIsoStore = initBrowserStores({
        browser: { ...commonBrowser, ...urlIsoBrowser },
        env: { ...desktopEnv, ...urlIsoEnv },
    }, false);

    mobileUrlIsoStore = initBrowserStores({
        browser: { ...commonBrowser, ...urlIsoBrowser },
        env: { ...mobileEnv, ...urlIsoEnv },
    }, false);

    urlIsoStores = [this.desktopUrlIsoStore, this.mobileUrlIsoStore];

    getAllStores = () => [
        ...(this.props.console.canAccessBrowserIso() ? this.browserIsoStores : []),
        ...(this.props.console.urlIsolationProductEnabled ? this.urlIsoStores : []),
    ];

    propagateOptionsToMockStores = () => {
        const opt = this.props.browserBarOptions;
        this.getAllStores().forEach(({ browser }) => browser.updateBrowserBarOptions(opt));
        this.getAllStores()[0].browser.customBrandingInfoDropdown.setValue(opt.helpButton !== HelpButton.DISABLED
            && opt.helpButtonAction === HelpButtonAction.POPUP);
    }

    componentDidMount() {
        this.propagateOptionsToMockStores();
    }

    componentDidUpdate() {
        this.propagateOptionsToMockStores();
    }

    renderProduct(title, desktopStore, mobileStore) {
        return <div className={block('Product')}>
            <FTBody>{title}</FTBody>
            <div className={block('Desktop')}>
                <div className={block('DesktopWrapper')}>
                    <Provider {...desktopStore}>
                        <TopBarAlternative />
                    </Provider>
                </div>
            </div>
            <div className={block('Mobile')}>
                <Provider {...mobileStore}>
                    <TopBarAlternative />
                </Provider>
            </div>
        </div>;
    }

    render() {
        const { console } = this.props;
        return <div className={block()}>
            {console.canAccessBrowserIso()
                ? this.renderProduct('Browser and Email Isolation', ...this.browserIsoStores)
                : null}
            {console.hasUrlIsolation()
                ? this.renderProduct('URL Isolation', ...this.urlIsoStores)
                : null}
        </div>;
    }
}

export default inject('console')(observer(BrowserBarPreview));
